<ng-container *transloco="let t; read: 'dashboard-options-component.dashboard-option-permissions'">
  <section>
    <div class="section-title">
      <h3>{{ t('lock-dashboard') }}</h3>

      <p>
        {{ t('lock-details') }}
      </p>
    </div>

    <div class="section-field">
      <div class="locked-switch-and-info">
        <xi-default-button
          text="{{ dashboardOriginal.locked ? t('lock-text-unlock') : t('lock-text-lock') }}"
          fill="outline"
          (onClick)="onLockToggle()"
          [disabled]="isReadOnly"
        ></xi-default-button>

        <xi-tool-tip-content
          [tooltip]="{
            direction: 6,
            text: t('lock-tooltip'),
          }"
        ></xi-tool-tip-content>
      </div>
    </div>
  </section>

  <section>
    <div class="section-title">
      <h3>{{ t('executive-view') }}</h3>

      <p>{{ t('ev-details') }}</p>
    </div>

    <div class="section-field">
      <label>{{ t('executive-view') }}</label>

      <div class="executive-switch-and-info">
        <xi-toggle-switch
          color="CX"
          [isToggled]="dashboardOriginal.payload.isExecutive"
          (onToggle)="onExecutiveToggle($event.detail.isToggled)"
          [disabled]="isReadOnly || dashboard.locked"
          leftText="{{ t('executive-view-text-off') }}"
          rightText="{{ t('executive-view-text-on') }}"
        ></xi-toggle-switch>

        <xi-tool-tip-content
          [tooltip]="{
            direction: 6,
            text: t('ev-tooltip'),
          }"
        ></xi-tool-tip-content>
      </div>
    </div>
  </section>

  @if (isHideVisible) {
    <section>
      <div class="section-title">
        <h3>{{ t('hidden-dashboard') }}</h3>
        <p>
          {{ t('hidden-details') }}
        </p>
      </div>
      <div class="section-field">
        <label>{{ t('hidden') }}</label>
        <div class="locked-switch-and-info">
          <xi-toggle-switch
            color="CX"
            [isToggled]="dashboardOriginal.visibility === 'UNLISTED'"
            (onToggle)="onHideToggle($event.detail.isToggled)"
            [disabled]="isReadOnly"
            leftText="{{ t('public') }}"
            rightText="{{ t('hidden') }}"
          ></xi-toggle-switch>
          <xi-tool-tip-content
            [tooltip]="{
              direction: 6,
              text: t('hidden-tooltip'),
            }"
          ></xi-tool-tip-content>
        </div>
      </div>
    </section>
  }
</ng-container>
